<template>
    <div>
        <div class="headingWizard hidePrint">
            Reschedule Appointment (Acknowledgement)
        </div>
        <div class="widthContainer">
            <div class="pageLayout reSchduleWidth">
                <div class="ackDetails">
                    <p>
                        <b>
                            Thank you!
                        </b>
                    </p>
                    <p>
                        You have successfully rescheduled your appointment to<b> {{
                            formatApptDate(appointmentDateString) }},
                            {{ formatTime12(appointmentDetails.startTime) }}</b>.
                    </p>
                    <p>
                        An SMS and/or email notification will be sent to you.
                    </p>
                    <p>
                        Your appointment will be at Land Transport Authority Customer Service Centre, 10 Sin Ming Drive,
                        Singapore 575701.
                    </p>
                    <ul class="listBullet">
                        <li>
                            Please arrive 15 minutes ahead of your appointment time. If you are late, your appointment
                            may be delayed or cancelled.
                        </li>
                        <li>
                            When you arrive at the <b> Customer Service Centre at
                                {{ appointmentDetails.waitingArea }}</b>, obtain a queue number at the self-service
                            kiosk
                            by entering your Appointment Reference ID <b> {{ appointmentDetails.referenceNumber }}</b>
                            or
                            scan the QR code provided in your email.
                        </li>
                    </ul>
                    <p v-html="appointmentDetails.postBookingMessage" class="postMessageMargin"></p>
                    <p v-html="appointmentDetails.oldPostBookingMessage" class="postMessageMargin"></p>
                </div>
                <div class="infoTable ackPage">
                    <table>
                        <thead>
                            <tr>
                                <th>
                                    <div class="lableText"><i> Appointment Date </i> </div>
                                    <div class="detailsText">
                                        {{ formatApptDate(appointmentDateString) }}
                                    </div>
                                </th>
                                <th>
                                    <div class="lableText">
                                        <i> Appointment Time</i>
                                    </div>
                                    <div class="detailsText">
                                        {{ formatTime12(appointmentDetails.startTime) }}
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td colspan="2">
                                    <div class="barCode">
                                        <qrcode-vue :value="value" size="150" level="H"></qrcode-vue>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                        <tbody>
                            <tr>
                                <td colspan="2">
                                    <div class="lableText">
                                        Name
                                    </div>
                                    <div class="detailsText">
                                        {{ appointmentDetails.name }}
                                    </div>
                                </td>

                            </tr>
                            <tr>
                                <td>
                                    <div class="lableText">
                                        Mobile Number
                                    </div>
                                    <div class="detailsText">
                                        <span v-if="appointmentDetails.phoneNumber">
                                            <span class="hidePrint"> {{ appointmentDetails.phoneNumber }} </span>
                                            <span class="hideOnView">{{ maskingText(appointmentDetails.phoneNumber, 4)
                                                }} </span>
                                        </span>
                                        <span v-else>
                                            -
                                        </span>
                                    </div>
                                </td>
                                <td>
                                    <div class="lableText">
                                        Email Address
                                    </div>
                                    <div class="detailsText">
                                        <span v-if="appointmentDetails.email">
                                            <span class="hidePrint"> {{ appointmentDetails.email }} </span>
                                            <span class="hideOnView">{{ emailMask(appointmentDetails.email) }}</span>
                                        </span>
                                        <span v-else>
                                            -
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                        <tbody>
                            <tr>
                                <td>
                                    <div class="lableText">
                                        Service Name
                                    </div>
                                    <div class="detailsText">
                                        {{ appointmentDetails.serviceName }}
                                    </div>
                                </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td colspan="2" class="p-0">
                                    <div class="appInfoDetails" v-if="isVehicalShow">
                                        <div class="lableText">
                                            Vehicle Number
                                        </div>
                                        <div class="detailsText">
                                            {{ capitalize(appointmentDetails.vehicleNumber) }}
                                        </div>
                                    </div>

                                    <div class="appInfoDetails" v-if="isNoticeShow">
                                        <div class="lableText">
                                            Notice Number
                                        </div>
                                        <div class="detailsText">
                                            {{ capitalize(appointmentDetails.noticeNumber) }}
                                        </div>
                                    </div>

                                    <div class="appInfoDetails" v-if="isVacShow">
                                        <div class="lableText">
                                            VAC Number
                                        </div>
                                        <div class="detailsText">
                                            {{ capitalize(appointmentDetails.vacNumber) }}
                                        </div>
                                    </div>

                                    <div class="appInfoDetails" v-if="isPARFShow">
                                        <div class="lableText">
                                            PARF Number
                                        </div>
                                        <div class="detailsText">
                                            {{ capitalize(appointmentDetails.parfNumber) }}
                                        </div>
                                    </div>

                                    <div class="appInfoDetails" v-if="isCEORShow">
                                        <div class="lableText">
                                            COE Number
                                        </div>
                                        <div class="detailsText">
                                            {{ capitalize(appointmentDetails.coeNumber) }}
                                        </div>
                                    </div>

                                    <div class="appInfoDetails" v-if="isTcoeShow">
                                        <div class="lableText">
                                            TCOE Number
                                        </div>
                                        <div class="detailsText">
                                            {{ capitalize(appointmentDetails.tcoeNumber) }}
                                        </div>
                                    </div>

                                    <div class="appInfoDetails" v-if="ishVParkShow">
                                        <div class="lableText">
                                            HV Park Number
                                        </div>
                                        <div class="detailsText">
                                            {{ capitalize(appointmentDetails.hvParkNumber) }}
                                        </div>
                                    </div>

                                    <div class="appInfoDetails" v-if="isDeviceNumberShow">
                                        <div class="lableText">
                                            Device Number
                                        </div>
                                        <div class="detailsText">
                                            {{ capitalize(appointmentDetails.deviceNumber) }}
                                        </div>
                                    </div>

                                </td>
                            </tr>
                            <tr>
                                <td colspan="2">
                                    <div class="lableText">
                                        Notes to LTA
                                    </div>
                                    <div class="detailsText" v-html="appointmentDetails.remarks">
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                        <tbody>
                            <tr>
                                <td>
                                    <div class="lableText">
                                        Appointment Reference ID
                                    </div>
                                    <div class="detailsText">
                                        {{ appointmentDetails.referenceNumber }}
                                    </div>
                                </td>
                                <td>
                                    <div class="lableText">
                                        Transaction Date & Time
                                    </div>
                                    <div class="detailsText">
                                        {{ appointmentTransactDateTime }}
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <p>
                    Your appointment will be at Land Transport Authority Customer Service Centre, 10 Sin Ming Drive,
                    Singapore 575701.
                </p>
                <div class="buttonContainer hidePrint">
                    <div class="magBtn">
                        <div class="leftButtons">
                            <Button label="< Home" @click="onHomeclick" class="linkBtn customLinkCss" />
                        </div>
                        <div class="rightButtons">
                            <Button @click="saveAsPdf" label="Save as PDF" class="btn p-button-raised" />
                            <Button label="Print" @click="printWindow" class="btn p-button-raised" />
                        </div>
                    </div>
                </div>
                <!-- <div class="buttonContainer hidePrint">
                    <div class="magBtn">

                        <div class="p-col-12 p-md-4">
                        </div>
                        <Button label="< Home" @click="onHomeclick()" class="linkBtn customLinkCss" />
                        <span class="printBtn">
                            <Button @click="saveAsPdf" label="Save as PDF" class="btn p-button-raised" />
                            <Button label="Print" @click="printWindow()" class="btn p-button-raised" />
                        </span>
                    </div>

                </div> -->
            </div>
        </div>
    </div>
</template>
<style>
.hideOnView {
    visibility: hidden;
    height: 0;
    overflow: hidden;
    display: none;
}
.buttonContainer .magBtn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  padding: 10px;
  margin-top: 10px !important;
}

.leftButtons {
  flex: 1;
  display: flex;
  justify-content: flex-start;
}

.rightButtons {
  display: flex;
  gap: 10px; 
  justify-content: flex-end;
}

@media print {
    .hidePrint {
        visibility: hidden;
        height: 0;
        overflow: hidden;
        display: none;
    }

    .hideOnView {
        visibility: visible;
        height: auto;
        overflow: auto;
        display: block;
    }
}
</style>
<script setup>
import { ref, computed, watch, onBeforeMount } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import QrcodeVue from 'qrcode.vue';
import { useApiService } from '@/utils/useApiService';
const { fetchWrapperForGet } = useApiService()
const store = useStore();
const router = useRouter();


defineExpose({ QrcodeVue });


const value = ref('');
const isShowQrcode = ref(false);
const isVehicalShow = ref(false);
const isNoticeShow = ref(false);
const isVacShow = ref(false);
const isPARFShow = ref(false);
const isCEORShow = ref(false);
const isTcoeShow = ref(false);
const ishVParkShow = ref(false);
const isDeviceNumberShow = ref(false);
const url = ref('');
const appointmentDateString = ref('');
const appointmentTransactDateTime = ref('');

const appointmentDetails = ref({
    name: "", phoneNumber: "", email: "", serviceName: "", remarks: "", referenceNumber: "",
    vehicleNumber: "", noticeNumber: "", vacNumber: "", parfNumber: "", coeNumber: "", tcoeNumber: "",
    deviceNumber: "", hvParkNumber: "", postBookingMessage: "", waitingArea: "",
    referenceNumber: "", appointmentDateTime: "", generateDateTime: "", appointmentDate: "",
    startTime: "", endTime: "", oldPostBookingMessage: ""
});


onBeforeMount(async () => {
    appointmentDetails.value = store.getters.getAppointmentAcknowlegement;
    appointmentDateString.value = appointmentDetails.value.appointmentDate;
    appointmentTransactDateTime.value = store.getters.getTransactionDateString;

    await store.dispatch('reset');

    if (appointmentDetails.value.id) {
        url.value = `api/api/appointments/file?pdfType=reschedule`;
        value.value = `${appointmentDetails.value.referenceNumber}`;
        isShowQrcode.value = true;
    } else {
        await store.dispatch('reset');
        router.push({ path: `/` });
    }
});

// methods
function maskingText(value, lastCharCount) {
    value = value.toString();
    if (value && value.length > lastCharCount) {
        value = '*'.repeat(value.length - lastCharCount) + value.slice(-lastCharCount);
    }
    return value;
}

function formatTime12(value) {
    if (value) {
        const [hoursStr, minutesStr] = value.split(':');
        let hours = parseInt(hoursStr, 10);
        const minutes = parseInt(minutesStr, 10);
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
        return `${hours}:${String(minutes).padStart(2, '0')} ${ampm}`;
    }
    return value;
}
function formatApptDate(dateStr) {
    const [yyyy, mm, dd] = dateStr.split('T')[0].split('-')
    const d = new Date(`${yyyy}-${mm}-${dd}`) 

    const day = String(dd).padStart(2, '0')
    const monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"]
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]

    const month = monthNames[d.getMonth()]
    const weekday = days[d.getDay()]
    const year = d.getFullYear()

    return `${day} ${month} ${year}, ${weekday}`
}
function emailMask(email) {
    let maskedEmail = email.replace(/([^@\.])/g, "*").split('');
    const ind = email.indexOf("@");
    for (let i = 0; i < maskedEmail.length; i++) {
        if (i <= ind) {
            maskedEmail[i] = email[i];
        }
    }
    return maskedEmail.join('');
}

function onHomeclick() {
    store.dispatch('reset').then(() => {
        router.push({ path: `/` });
    });
}

function printWindow() {
    window.print();
}

function okFunction() {
    fetchWrapperForGet(`api/MopSessions/Delete`, false, false, true).then(() => {
        store.dispatch('reset').then(() => {
            window.location.reload();
        });
    });
}

function saveAsPdf() {
    fetchWrapperForGet(`api/HeartBeat`, false, false, false).then(() => {
        window.open(url.value);
    }).catch((err) => {
        if (err.errorCode === 422) {
            notifyInfoError("Your session has expired due to inactivity. To download appointment details, please select \"Enquire / Manage Appointment\" option and try again.", okFunction);
        } else {
            notifyError(err);
        }
    });
}
function capitalize(value) {
    if (!value) return "";
    value = value.toString();
    return value.toUpperCase();
}
// computed (watch sources)
const onVehicalNumberChange = computed(() => appointmentDetails.value.vehicleNumber);
const onNoticeNumberChange = computed(() => appointmentDetails.value.noticeNumber);
const onVACNumberChange = computed(() => appointmentDetails.value.vacNumber);
const onPARFNumberChange = computed(() => appointmentDetails.value.parfNumber);
const onCOENumberChange = computed(() => appointmentDetails.value.coeNumber);
const onTCOENumberChange = computed(() => appointmentDetails.value.tcoeNumber);
const onHVParkNumberChange = computed(() => appointmentDetails.value.hvParkNumber);
const onDeviceNumberChange = computed(() => appointmentDetails.value.deviceNumber);

// watchers
watch(onVehicalNumberChange, val => { if (val) isVehicalShow.value = true });
watch(onNoticeNumberChange, val => { if (val) isNoticeShow.value = true });
watch(onVACNumberChange, val => { if (val) isVacShow.value = true });
watch(onPARFNumberChange, val => { if (val) isPARFShow.value = true });
watch(onCOENumberChange, val => { if (val) isCEORShow.value = true });
watch(onTCOENumberChange, val => { if (val) isTcoeShow.value = true });
watch(onHVParkNumberChange, val => { if (val) ishVParkShow.value = true });
watch(onDeviceNumberChange, val => { if (val) isDeviceNumberShow.value = true });


</script>

<style>
.maxWidth {
    max-width: 840px;
    margin: 0 auto;
    width: 100%;
}

.contentSection {
    padding: 0 15px;
}

.detailsText {
    font-weight: bold;
}

.float-right {
    float: right;
}

body .linkBtn.customLinkCss {
    background: none !important;
    border: none !important;
    color: #3f4fa0 !important;
}

.customLinkCss {
    background: #000;
}

.body .p-button.p-button-success,
body .p-buttonset.p-button-success>.p-button {
    color: #ffffff;
    background-color: #8290d0;
    border: #8290d0;
}

.reSchduleWidth {
    max-width: 840px;
}
</style>
